import { LEAD_ID, LEAD_IS_REQUESTING, LEAD_REQUESTING_END, ERROR_STATE } from "./types";
import moment from "moment";
import $ from "jquery";
import axios from "axios";


function getErrorState(getState, data, url){
  var values = {};
  var type = getState.inquires.home.type;
  values.eventName = "error "+url+" "+data;
  var iframeData = ["setData", values];
  console.log('iframeData :'+ iframeData );
  window.top.postMessage(iframeData , '*');
  console.log(values);
}

export const leadCall = (data, url) => {
  return (dispatch, getState) => {
    dispatch({
      type: LEAD_IS_REQUESTING,
    })
    data.campaignid=100298;
    data.campaignid_default=100298;
    data.gender= getState().inquires.user.civility === 'Madame' ? 'F' : 'M';
    data.last_name=getState().inquires.user.lastname;
    data.first_name=getState().inquires.user.firstname;
    data.adress=getState().inquires.user.address;
    data.city =getState().inquires.user.city;
    data.phone=getState().inquires.user.phone_number;
    data.email=getState().inquires.user.email;
    data.zip_code = getState().inquires.user.zip_code;
    data.noconfirmmail=1;
    if(getState().restIntel.intel.dealerInfo.idCar!== undefined){
      data.model = getState().restIntel.intel.dealerInfo.idCar
    }
    if(getState().inquires.user.optin==="oui"){
      data.privacy_email = "G";
    } else if(getState().inquires.user.optin==="non"){
      data.privacy_email = "F";
    } else  {
      data.privacy_email = "U";
    }
    let arrLead="";
    // console.log("REQUIRE => ",data);
// //debugger;
//     $.ajax( {
//       url: "https://www.seat-leadconnect.fr/webservices/" + url,
//       data: data,
//       async: true,
//       crossDomain: true,
//       method: "POST",
//       dataType: "text",
//       cache: false,
//       xhrFields: {
//         withCredentials: true
//       },
//       contentType: "application/x-www-form-urlencoded",
//     } )
//     .done(function(data) {
//       console.log('llllaaaa')
//       var tab= new RegExp('\r\n|\r|\n');
//       arrLead = data.split(tab);
//       if(url=="leads"){
//         if(arrLead[0]=="OK" && arrLead[2].length>0){
//           dispatch({
//             type: LEAD_ID,
//             data: Number(arrLead[2])
//           });
//         } else {
//           //TACKING ERROR FN
//           getErrorState(getState(),data,url);
//         }
//       } else {
//         arrLead = JSON.parse(arrLead[0]);
//         if(arrLead['status']!=="OK"){
//           getErrorState(getState(),data,url);
//         }
//       }
//     })
//     .fail(function(jqXHR,textStatus,errorThrown) {
//       console.log('error ici ')
//       console.log(jqXHR.statusCode())
//       console.log(jqXHR, textStatus, errorThrown)
//       getErrorState(getState(),data,url);
//     })
//     .always(function(jqXHR) {
//       console.log(data);
//       dispatch({
//         type: LEAD_REQUESTING_END,
//       })
//     });
    console.log('-------LEAD-------');
    console.log(data);
    $.ajax({
      url: "https://www.seat-leadconnect.fr/webservices/" + url,
      data: data,
      type: "post",
      crossDomain: true,
      dataType: "text",
      cache: false,
      withCredentials: true,

      contentType: "application/x-www-form-urlencoded",
      success: function(data) {
        console.log('success');
        console.log(data);
        var tab= new RegExp('\r\n|\r|\n');
        arrLead = data.split(tab);
        if(url=="leads"){
          if(arrLead[0]=="OK" && arrLead[2].length>0){
            dispatch({
              type: LEAD_ID,
              data: Number(arrLead[2])
            });
          } else {
            //TACKING ERROR FN
            getErrorState(getState(),data,url);
          }
        } else {
          arrLead = JSON.parse(arrLead[0]);
          if(arrLead['status']!=="OK"){
            getErrorState(getState(),data,url);
          }
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log('error')
        console.log(jqXHR.statusCode())
        console.log(jqXHR, textStatus, errorThrown)
        getErrorState(getState(),data,url);
      },
      complete: function(jqXHR, textStatus) {
        console.log(data);
        dispatch({
          type: LEAD_REQUESTING_END,
        })
      }
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/lead.js